module.exports = __webpack_public_path__ + "static/media/index_bg1.26cef7a4.png";